import { Theme, useTheme } from '@mui/material';
import React, { useContext } from 'react';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { useIsSmallBreakpoint } from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import { TEDLRFakturaDelAttestMinaStatusEnum } from '../../../../../../../globalQueryTypes';
import { ValueType } from '../../../../../../../Utils/Formatters/FormatterTypes';
import { BusinessDataFormContext } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import { useVisningstypContext } from '../../../../../_Common/Components/BusinessCollectionComponents/VisningsTypContext/VisningsTypContext';

interface IProps {
  value: ValueType;
  displayValue: string;
}

interface IStatusColor {
  backgroundColor: string;
  fontColor: string;
}

const getStatusColor = (value: string, theme: Theme): IStatusColor => {
  let result = { fontColor: '', backgroundColor: '' };
  switch (value) {
    case TEDLRFakturaDelAttestMinaStatusEnum.EJ_ATTESTERAD__HOS_ANNAN_ATTESTANT:
      result.backgroundColor = theme.customProperties.Legend.indigo.faded;
      result.fontColor = theme.customProperties.Legend.indigo.full;
      break;
    case TEDLRFakturaDelAttestMinaStatusEnum.UNDER_UTREDNING:
      result.backgroundColor = theme.customProperties.Legend.red.faded;
      result.fontColor = theme.customProperties.Legend.red.full;
      break;
    case TEDLRFakturaDelAttestMinaStatusEnum.MOTTAGNINGSATTESTERAS:
    case TEDLRFakturaDelAttestMinaStatusEnum.BESLUTSATTESTERAS:
    case TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS:
      result.backgroundColor = theme.customProperties.Legend.lightBlue.faded;
      result.fontColor = theme.customProperties.Legend.lightBlue.full;
      break;
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__HOS_ANNAN_ATTESTANT:
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__BETALD:
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__DEFINITIVBOKAD:
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__DELBETALD:
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__EJ_DEFINITIVBOKAD:
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__MAKULERAD:
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__PA_VAG_TILL_BETALNING:
    case TEDLRFakturaDelAttestMinaStatusEnum.ATTESTERAD__SPARRAD:
      result.backgroundColor = theme.customProperties.Legend.darkGreen.faded;
      result.fontColor = theme.customProperties.Legend.darkGreen.full;
      break;

    default:
      break;
  }
  return result;
};

const AttestMinaStatusComp: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const theme = useTheme();
  const formContext = useContext(BusinessDataFormContext);
  const visningsTypContext = useVisningstypContext();
  const isSmallScreen = useIsSmallBreakpoint();

  const valueString: string = props?.value?.toLocaleString() ?? '';
  const statusColor = getStatusColor(valueString, theme);

  return (
    <EDTypography
      variant="inherit"
      sx={
        formContext ||
        isSmallScreen ||
        visningsTypContext.visningsTyp === 'kort' ||
        visningsTypContext.visningsTyp === 'lista'
          ? {}
          : {
              backgroundColor: statusColor.backgroundColor,
              minWidth: '227px',
              py: 0.75,
              px: 1.25,
              display: 'flex',
              alignItems: 'center',
              borderRadius: 2,
              justifyContent: 'center',
              color: 'text.primary',
              height: '34px',
              boxSizing: 'border-box',
              margin: '4px 0',
            }
      }
    >
      {props.displayValue}
    </EDTypography>
  );
};

export default AttestMinaStatusComp;
